import RoleService from "./role-service";
import httpClient from "./http-client";
import EntityService from "./entity-service";
import UserService from "./user";
import EntityDocumentationService from "./entity-documentation-service";
import EntityDocumentationSettingsService from "./entity-documentation-settings-service";
import DocumentationSubmissionService from "./documentation-submission-service";
import CertificationComplianceService from "./certification-compliance-service";
import DocumentationService from "./documentation-service";
import AsyncPaginatedRequest from "./async-paginated-request";
import {AuthorizarionServiceWithOverride, SuperAdminPolicyOverride,} from "./authorization-service";
import entityPolicyMap from "@/policies/entity";
import submissionPolicyMap from "@/policies/submission";
import videoPolicyMap from "../policies/videos";
import reportPolicyMap from "../policies/monthly-reports";
import newsPolicyMap from "../policies/news";
import budgetExecutionAccountPolicyMap from "../policies/budget-execution-account";
import missingSubmissionPolicyMap from "../policies/missing-submission";
import userPolicyMap from "../policies/user";
import graphPolicyMap from "../policies/sentiment-graph";
import respondRequestPolicyMap from "../policies/respond-request";
import periodExtensionPolicyMap from "@/policies/period-extension";
import advertisementPolicyMap from "@/policies/advertisement";
import micrositesPolicyMap from "@/policies/microsites";
import carouselPolicyMap from "@/policies/carousel";
import logoPolicyMap from "@/policies/logo";
import EntityComplianceService from "./entity-compliance-service";
import {BindableHttpClient} from "./http-service";
import NewsService from "./news-service";
import VideoService from "./video-service";
import DocumentationGroupService from "./documentation-group-service";
import EntitySubmissionExtensionService from "./entity-submission-extension-service";
import DocumentationExplanationFile from "./documentation-example-file";
import ImageUploadService from "./image-upload-service";
import PayrollsService from "./payroll-service";
import miscPolicies from "@/policies/misc";
import certificacionPolicies from "@/policies/certification";
import EntityTypeService from "./entitiy-type-service";
import citizenPolicy from "../policies/citizen";
import CitizenInformationRequestService from "./citizen-information-request-service";
import ResponseInformationRequestService from "./response-information-request-service";
import BudgetExecutionService from "./budget-execution";
import TerritorialDivisionService from "./territorial-division";
import EthnicGroupService from "./ethinc-group-service";
import AnnualReport from "./annual-report";
import MicroSiteService from "@/services/micro-site-service";
import AdvertisementService from "@/services/advertisement-service";
import CarouselService from "@/services/carousel-service";
import StatisticsService from "@/services/statistics-service"
import GenderService from "./genders-service";
import AlertsService from "./alerts-service";
import InstitutionAdminReportService from "./institution-admin-report-service";
import BudgetExecutionAccountService from "@/services/budget-execution-account-service";
import MissingSubmissionService from "@/services/missing-submission-service";

export { AsyncPaginatedRequest };

export const roleService = new RoleService();
export const entityService = new EntityService();
export const userService = new UserService();
export const entityDocumentationService = new EntityDocumentationService();
export const entityDocumentationSettingsService =
  new EntityDocumentationSettingsService();
export const submissionService = new DocumentationSubmissionService();
export const documentationService = new DocumentationService();
export const entityComplianceService = new EntityComplianceService();
export const newsService = new NewsService();
export const payrollService = new PayrollsService();
export const videoService = new VideoService();
export const documentationGroupService = new DocumentationGroupService();
export const entitySubmissionExtensionService =
  new EntitySubmissionExtensionService();
export const documentationExplanationFile = new DocumentationExplanationFile();
export const imageUploadService = new ImageUploadService();
export const certificationComplianceService =
  new CertificationComplianceService();
export const entityTypeService = new EntityTypeService();
export const citizenInformationRequestService =
  new CitizenInformationRequestService();
export const responseInformationRequestService =
  new ResponseInformationRequestService();
export const budgetExecutionService = new BudgetExecutionService();
export const territorialDivisionService = new TerritorialDivisionService();
export const ethnicGroupService = new EthnicGroupService();
export const annualReport = new AnnualReport();
export const microSiteService = new MicroSiteService();
export const advertisementService = new AdvertisementService();
export const carouselService = new CarouselService();
export const statisticsService = new StatisticsService()
export const genderService = new GenderService();
export const alertService = new AlertsService();
export const institutionAdminReportService = new InstitutionAdminReportService();
export const budgetExecutionAccountService = new BudgetExecutionAccountService();
export const missingSubmissionService = new MissingSubmissionService();

export const authorizationService = new AuthorizarionServiceWithOverride(
  new Map([
    ...entityPolicyMap.entries(),
    ...submissionPolicyMap.entries(),
    ...periodExtensionPolicyMap.entries(),
    ...videoPolicyMap.entries(),
    ...reportPolicyMap.entries(),
    ...newsPolicyMap.entries(),
    ...miscPolicies.entries(),
    ...userPolicyMap.entries(),
    ...certificacionPolicies.entries(),
    ...citizenPolicy.entries(),
    ...graphPolicyMap.entries(),
    ...respondRequestPolicyMap.entries(),
    ...advertisementPolicyMap.entries(),
    ...carouselPolicyMap.entries(),
    ...micrositesPolicyMap.entries(),
    ...budgetExecutionAccountPolicyMap.entries(),
    ...missingSubmissionPolicyMap.entries(),
    ...logoPolicyMap.entries()
  ]),
  SuperAdminPolicyOverride
);

const httpServices: BindableHttpClient[] = [
  alertService,
  genderService,
  entityComplianceService,
  roleService,
  entitySubmissionExtensionService,
  entityService,
  userService,
  entityDocumentationSettingsService,
  submissionService,
  documentationService,
  entityDocumentationService,
  newsService,
  videoService,
  documentationGroupService,
  documentationExplanationFile,
  imageUploadService,
  payrollService,
  certificationComplianceService,
  citizenInformationRequestService,
  responseInformationRequestService,
  budgetExecutionService,
  territorialDivisionService,
  ethnicGroupService,
  annualReport,
  microSiteService,
  advertisementService,
  carouselService,
  statisticsService,
  institutionAdminReportService,
  budgetExecutionAccountService,
  missingSubmissionService
];

httpServices.forEach((service) => {
  service.setHttpClient(httpClient);
});
